<template lang="pug">
div(v-if="cadastroOriginal")
  el-tabs.tabs(
    @tab-click="handleClick",
    v-model="abaAtiva",
  )
    el-tab-pane.tab(name='qualificacao', v-if='(isOnerosoGroup || isProcessoFisico || isReurb) && !isGeoCadastro')
      span(slot='label')
        .label
          | Geral &nbsp
      informacoes-qualificacao-rr(v-if="isRoraima", :qualificacao="cadastroOriginal.qualificacao", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro" :cadastroOriginal="cadastroOriginal",:pessoas="processo.pessoas", :dataRetificacao="processo.dataRetificacao")
      informacoes-qualificacao(v-if="cadastroOriginal.tipo==='NAO_ONEROSO' || isReurb || isProcessoFisico", :qualificacao="cadastroOriginal.qualificacao", :tipo="tipoCadastro(processo.tipo.nome)", :dataCadastro="processo.dataCadastro" :cadastroOriginal="cadastroOriginal",:pessoas="processo.pessoas",:compararQualificacao="compararRetificacoes.mudouQualificacaoDTO", :dataRetificacao="processo.dataRetificacao" :isProcessoFisico="isProcessoFisico" :idProcesso="processo.id")
      informacoes-qualificacao-oneroso(v-if="cadastroOriginal.tipo==='ONEROSO'", :qualificacao="cadastroOriginal.qualificacao", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro", :pessoas="processo.pessoas", :compararQualificacaoOneroso="compararRetificacoes.mudouQualificacaoDTO", :dataRetificacao="processo.dataRetificacao")
      informacoes-qualificacao-certidao(v-if="cadastroOriginal.tipo==='CERTIDAO_TITULO'", :qualificacao="cadastroOriginal.qualificacao", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro",:pessoas="processo.pessoas", :compararQualificacaoCertidao="compararRetificacoes.mudouQualificacaoDTO", :dataRetificacao="processo.dataRetificacao")

    el-tab-pane.tab(name='geralTeq', v-if="isTeqGroup && !isGeoCadastro")
      span(slot="label")
        .label
          | Geral &nbsp
      informacoes-qualificacao(:cadastroOriginal="cadastroOriginal" :qualificacao="cadastroOriginal.qualificacao", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro", :compararQualificacao="compararRetificacoes.mudouQualificacaoDTO", :dataRetificacao="processo.dataRetificacao", :pessoas="processo.pessoas")
    el-tab-pane.tab(name='cadastrante' v-if="!isGeoCadastro")
      span(slot="label")
        .label
          | {{ isBahia ? 'Executor' : 'Cadastrante' }} &nbsp
      informacoes-cadastrante(
        :cadastrante="cadastrante",
        :isOnerosoGroup="isOnerosoGroup",
        v-if="!isTeqGroup",
        :compararCadastrante="compararRetificacoes.mudouCadastranteDTO",
        :tipoProcesso="tipoProcesso",
        :isProcessoFisico="isProcessoFisico"
      )
      div(v-for = "(membro, index) in cadastrante.membrosComunidade")
      app-teq-group(
        :cadastroOriginal="cadastroOriginal",
        :cadastrante="cadastrante",
        :show-membro-endereco="true",
        v-if="isTeqGroup"
        :compararTeqGroup="compararRetificacoes.mudouCadastranteDTO"
      )
      listagem-documentos(
        v-if="cadastrante.documentos && cadastrante.documentos.length > 0"
        :documentos="cadastrante.documentos",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        ownerDocumento="CADASTRANTE"
        :compararDocumentos="compararRetificacoes.mudouCadastranteDTO.mudouDocumentosCadastrante"
        :versaoCadastro = "versaoCadastro"
        :isCadastroPendente="isCadastroPendente"
      )

    el-tab-pane.tab(name='interessado' v-if="!isGeoCadastro")
      span(slot="label")
        .label
          | Interessado &nbsp
      div(v-if="!isMultiplosInteressados")
        informacoes-interessado(
          :interessado="interessado",
          :cadastroOriginal="cadastroOriginal",
          :isOnerosoGroup="isOnerosoGroup",
          :isReurb="isReurb",
          :compararInteressado="compararRetificacoes.mudouInteressadoDTO"
          :versaoCadastro = "versaoCadastro"
        )

        listagem-documentos(
          v-if="interessado.documentos && interessado.documentos.length > 0"
          :documentos="interessado.documentos",
          :protocoloCadastroOriginal="cadastroOriginal.protocolo"
          ownerDocumento="INTERESSADO"
          :compararDocumentos="compararRetificacoes.mudouInteressadoDTO.mudouDocumentosInteressado"
          :versaoCadastro = "versaoCadastro"
          :isCadastroPendente="isCadastroPendente"
        )
      div(v-else)
        el-collapse
          el-collapse-item(v-for="(interessado, index) in interessadosLista", :title="interessado.pessoa.pessoaFisica.nome", :key="index")
            informacoes-interessado(
              :interessado="interessado",
              :cadastroOriginal="cadastroOriginal",
              :isOnerosoGroup="isOnerosoGroup",
              :isReurb="isReurb",
              :compararInteressado="compararRetificacoes.mudouInteressadoDTO"
              :versaoCadastro = "versaoCadastro"
            )

            app-divider(v-if="isReurb" label="Assinatura")
            assinatura-mobile(:assinatura="assinatura", v-if="isReurb", :isAssinaturaInserida="interessado.isAssinaturaInserida")

            listagem-documentos(
              v-if="interessado.documentos && interessado.documentos.length > 0"
              :documentos="interessado.documentos",
              :protocoloCadastroOriginal="cadastroOriginal.protocolo"
              ownerDocumento="INTERESSADOS",
              :idInteressado="interessado._id || interessado.id"
              :compararDocumentos="compararRetificacoes.mudouInteressadoDTO.mudouDocumentosInteressado"
              :versaoCadastro = "versaoCadastro",
              :isCadastroPendente="isCadastroPendente"
            )
    el-tab-pane.tab(name='beneficiarios', v-if="(isTeqGroup && beneficiarios.length > 0) && !isGeoCadastro")
      span(slot="label")
        .label
          | Beneficiários &nbsp

      informacoes-beneficiarios(:beneficiarios="beneficiarios", :cadastroOriginal="cadastroOriginal", :isBeneficiariosDiferentes="compararRetificacoes.mudouBeneficiarios")

    el-tab-pane.tab(name='imovel' v-if="!isGeoCadastro")
      span(slot="label")
        .label
          | Imóvel &nbsp
      div(v-if="processo.tipo.codigo !== 'REGULARIZACAO_URBANA' && processo.tipo.codigo !== 'REURB_INDIVIDUAL'")
        informacoes-imovel(
          v-if="!isRoraima"
          :cadastroOriginal="cadastroOriginal",
          :isOneroso="cadastroOriginal.tipo === 'ONEROSO'"
          :isOnerosoGroup="cadastroOriginal.tipo === 'ONEROSO' || cadastroOriginal.tipo === 'NAO_ONEROSO'"
          :compararImovel="compararRetificacoes.mudouImovelDTO"
          :compararDestinacaoUsoImovel="compararRetificacoes.mudouDestinacaoUsoImovelDTO"
          :destinacaoUsoImovel="destinacaoUsoImovel",
        )
        informacoes-imovel-rr(
          v-else
          :cadastroOriginal="cadastroOriginal"
        )
        app-divider(label="Dados do Registro" v-if="isProcessoFisico")
        informacoes-registro-imovel(
          v-if="isProcessoFisico"
          :cadastroOriginal="cadastroOriginal"
        )
        listagem-documentos(
          v-if="imovel.documentos && imovel.documentos.length > 0"
          :documentos="imovel.documentos",
          :protocoloCadastroOriginal="cadastroOriginal.protocolo"
          ownerDocumento="IMOVEL",
          :isDetalhes="true",
          :interessado="interessado",
          :tempoOcupacao="imovel.tempoOcupacao"
          :compararDocumentos="compararRetificacoes.mudouImovelDTO.mudouDocumentosImovel"
          :versaoCadastro = "versaoCadastro"
          :isCadastroPendente="isCadastroPendente"
        )
      div(v-else)
        informacoes-imovel-reurb(
          :cadastroOriginal="cadastroOriginal",
          :compararImovelReurb="compararRetificacoes.mudouImovelDTO"
        )
    el-tab-pane.tab(name='destinacaoUso', v-if="!isPEAS && !isReurb && !isCCR && !isBahia && !isProcessoFisico && !isGeoCadastro")
      span(slot="label")
        .label
          | Destinação e uso do imóvel &nbsp
      informacoes-destinacaoUsoImovel(
        :destinacaoUsoImovel="destinacaoUsoImovel",
        :isOnerosoGroup="cadastroOriginal.tipo === 'ONEROSO' || cadastroOriginal.tipo === 'NAO_ONEROSO'",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        :compararDestinacaoUsoImovel="compararRetificacoes.mudouDestinacaoUsoImovelDTO"
      )

    el-tab-pane.tab(v-if="!isReurb && !isCCR && !isProcessoFisico && hasGeoBa" name='georreferenciamento')
      span(slot="label")
        .label
          | Georreferenciamento &nbsp
      app-resumo-geo(
        :localizacao="processo.geometria"
        :geo="georreferenciamento",
        :id-mapa="`mapaResumo${Math.random() * (10 - 0) + 0}`",
        v-if="abaAtiva == 'georreferenciamento' && !hasNotGeoReferenciamentoMa",
        :showMapa="naoPossuiGeorreferenciamento",
        :exibeDocumentos="false",
        :isVisualizarCadastro="true",
        :isGeoBeneficiario="false",
        :idCadastro="processo.numeroProtocolo",
        :isCadastroOff="true",
        :idProcesso="processo.id",
        :possuiCredenciadoGeo="possuiCredenciado()",
        :cruzamentoCamada="processo.cruzamentoCamada"
        :compararResumoGeo="compararRetificacoes.mudouGeorreferenciamentoDTO"
      )
      span(v-else-if="isMaranhao && abaAtiva == 'georreferenciamento' && hasNotGeoReferenciamentoMa")
        | Não foi informado nenhum dado durante o cadastro.

      listagem-documentos(
        v-if="(georreferenciamento.documentos && georreferenciamento.documentos.length > 0) || (processo.documentosAutenticaveis && processo.documentosAutenticaveis.length > 0)"
        :documentos="georreferenciamento.documentos",
        :documentosGeo="processo.documentosAutenticaveis",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        ownerDocumento="GEO",
        :addMarginTop="false"
        :compararDocumentos="compararRetificacoes.mudouGeorreferenciamentoDTO.mudouDocumentosGeorreferenciamento"
        :versaoCadastro = "versaoCadastro",
        :isCadastroPendente="isCadastroPendente"
      )

    el-tab-pane.tab(name='galeria', v-if="isReurb && !isGeoCadastro")
      span(slot="label")
        .label
          | Documentos &nbsp
      galeria(
        :loading="loading"
        :srcList="galeria",
        :imovel="imovel",
        :interessado="interessado",
        :protocolo="protocoloReurb",
        :compararGaleria="compararRetificacoes.mudouImovelDTO",
        :versaoCadastro="versaoCadastro"
      )

    el-tab-pane.tab(name='termoCompromisso' v-if="!isGeoCadastro")
      span(slot="label")
        .label
          | Termo de compromisso &nbsp
      informacoes-termo-compromisso(:isReurb="isReurb" :isProcessoFisico="isProcessoFisico")
      app-divider(v-if="isReurb" label="Assinatura")
      assinatura-mobile(:assinatura="assinatura", v-if="isReurb", :isAssinaturaInserida="interessado.isAssinaturaInserida")

</template>

<script>
import { mapActions } from 'vuex'
import ListagemDocumentos from './informacoesCadastro/ListagemDocumentos'
import AppDisplay from './AppDisplay'
import InformacoesCadastrante from './informacoesCadastro/InformacoesCadastrante'
import InformacoesInteressado from './informacoesCadastro/InformacoesInteressado'
import InformacoesDestinacaoUsoImovel from './informacoesCadastro/InformacoesDestinacaoUsoImovel'
import InformacoesImovel from './informacoesCadastro/InformacoesImovel'
import InformacoesImovelRr from './informacoesCadastro/InformacoesImovelRr'
import AppTeqGroup from './informacoesCadastro/TeqGroup'
import InformacoesBeneficiarios from './informacoesCadastro/InformacoesBeneficiarios.vue'
import AppVisualizarBeneficiario from './AppVisualizarBeneficiario'
import AppResumoGeo from './resumo/AppResumoGeo'
import AppResumoImovelBeneficiario from './resumo/AppResumoImovelBeneficiario'
import InformacoesQualificacao from './informacoesCadastro/informacoesQualificacao'
import InformacoesQualificacaoRr from './informacoesCadastro/InformacoesQualificacaoRr.vue'
import InformacoesQualificacaoCertidao from './informacoesCadastro/InformacoesQualificacaoCertidao'
import InformacoesQualificacaoOneroso from './informacoesCadastro/InformacoesQualificacaoOneroso'
import AppDivider from '@/components/AppDivider'
import InformacoesTermoCompromisso from '@/components/informacoesCadastro/InformacoesTermoCompromisso'
import AppCollapse from '@/components/AppCollapse'
import AppDependentes from './AppDependentes'
import InformacoesImovelReurb from './informacoesCadastro/InformacoesImovelReurb'
import Galeria from './informacoesCadastro/Galeria'
import AssinaturaMobile from './informacoesCadastro/AssinaturaMobile'
import InformacoesRegistroImovel from './informacoesCadastro/InformacoesRegistroImovel.vue'

import AppButton from './AppButton'
import compararRetificacoesDefault from '../utils/pa/compararReticacoesDefault'
const { tiposProcessoFisico, tiposImagensReurb } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppDivider,
    AppDisplay,
    InformacoesCadastrante,
    InformacoesInteressado,
    InformacoesDestinacaoUsoImovel,
    InformacoesImovel,
    InformacoesImovelRr,
    InformacoesBeneficiarios,
    AppTeqGroup,
    AppResumoGeo,
    AppVisualizarBeneficiario,
    AppResumoImovelBeneficiario,
    InformacoesQualificacao,
    InformacoesQualificacaoRr,
    InformacoesQualificacaoCertidao,
    InformacoesQualificacaoOneroso,
    ListagemDocumentos,
    AppButton,
    InformacoesTermoCompromisso,
    AppCollapse,
    AppDependentes,
    InformacoesImovelReurb,
    Galeria,
    AssinaturaMobile,
    InformacoesRegistroImovel
  },

  props: {
    processo: {
      type: Object,
      required: true
    },
    compararRetificacoes: {
      type: Object,
      default: compararRetificacoesDefault
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    },
    isCadastroPendente: {
      type: Boolean,
      default: false
    },
    isGeoCadastro: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      beneficiarioId: [],
      abaAtiva: '',
      loading: false,
      galeria: [],
      assinatura: [],
      tiposProcessoFisico,
      processoMae: {
        numeroProtocolo: ''
      }
    }
  },

  mounted () {
    if (this.isGeoCadastro) {
      this.abaAtiva = 'georreferenciamento'
    } else if (this.isOnerosoGroup) {
      this.abaAtiva = 'qualificacao'
    } else if (this.isTeqGroup) {
      this.abaAtiva = 'geralTeq'
    } else {
      this.abaAtiva = 'cadastrante'
    }
  },

  computed: {
    cadastroOriginal () {
      return this.processo.dadosCadastro.dados ? this.processo.dadosCadastro.dados.cadastro : this.processo.dadosCadastro
    },
    protocoloReurb () {
      this.abaAtiva = 'cadastrante' // eslint-disable-line
      return this.processo.numeroProtocolo
    },
    cadastrante () {
      return this.cadastroOriginal.cadastrante
        ? this.cadastroOriginal.cadastrante : {}
    },
    tipoProcesso () {
      return this.cadastroOriginal.tipo
    },
    interessado () {
      return this.cadastroOriginal.interessado.pessoa
        ? this.cadastroOriginal.interessado : {}
    },
    destinacaoUsoImovel () {
      return this.cadastroOriginal.destinacaoUsoImovel
        ? this.cadastroOriginal.destinacaoUsoImovel : {}
    },
    beneficiarios () {
      return this.cadastroOriginal.beneficiarios ? this.cadastroOriginal.beneficiarios : []
    },
    imovel () {
      return this.cadastroOriginal.imovel
        ? this.cadastroOriginal.imovel : {}
    },

    georreferenciamento () {
      return this.cadastroOriginal.georreferenciamento ? this.cadastroOriginal.georreferenciamento : {}
    },

    localizacoes () {
      return this.cadastroOriginal.georreferenciamento.localizacoes
        ? this.cadastroOriginal.georreferenciamento.localizacoes : []
    },

    isOnerosoGroup () {
      return this.cadastroOriginal.tipo === 'ONEROSO' ||
             this.cadastroOriginal.tipo === 'NAO_ONEROSO' ||
             this.cadastroOriginal.tipo === 'CERTIDAO_TITULO' ||
             this.cadastroOriginal.tipo === 'REGULARIZACAO_URBANA'
    },
    isTeqGroup () {
      return this.cadastroOriginal.tipo === 'TEQ' ||
             this.cadastroOriginal.tipo === 'PEAEX' ||
             this.cadastroOriginal.tipo === 'PEAS'
    },
    isPEAS () {
      return this.cadastroOriginal.tipo === 'PEAS'
    },
    isReurb () {
      return this.processo.tipo.codigo === 'REGULARIZACAO_URBANA' || this.processo.tipo.codigo === 'REURB_INDIVIDUAL'
    },
    isCCR () {
      return this.processo.tipo.codigo === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
    },
    isRoraima () {
      return process.env.ESTADO === 'rr'
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    isBahia () {
      return process.env.ESTADO === 'ba'
    },
    hasNotGeoReferenciamentoMa () {
      return !this.georreferenciamento.documentos?.length &&
             !this.georreferenciamento.localizacoes?.length &&
             !this.georreferenciamento.idsLocalizacoes?.length &&
             this.isMaranhao
    },
    hasGeoBa () {
      if (!this.isBahia) return true
      return (!this.isCadastroPendente && this.georreferenciamento.localizacoes?.length) || this.georreferenciamento?.jsonPlanilha
    },
    naoPossuiGeorreferenciamento () {
      return this.georreferenciamento.possuiGeorreferenciamento === 'NAO_POSSUI' || !this.georreferenciamento?.possuiGeorreferenciamento
    },
    isMultiplosInteressados () {
      return this.cadastroOriginal.isMultiplosInteressados
    },
    interessadosLista () {
      return this.cadastroOriginal.interessados.interessadosLista
    },
    isMembrosComunidade () {
      return this.cadastrante.tipo === 'MEMBROS_DA_COMUNIDADE'
    },
    isProcessoFisico () {
      return this.tiposProcessoFisico.includes(this.cadastroOriginal.tipo)
    }
  },

  methods: {
    ...mapActions({
      gerarSegundaVia: 'cadastro/emitirSegundaVia',
      buscarFotosReurb: 'cadastro/buscarFotosReurb'
    }),

    async handleClick (tab) {
      this.abaAtiva = tab.name

      if (tab.name === 'galeria' && this.galeria.length === 0) {
        try {
          this.loading = true
          this.galeria = await this.buscarFotosReurb({
            idProcesso: this.processo.id,
            tipo: 'GALERIA',
            protocolo: this.processo.numeroProtocolo,
            tipos: tiposImagensReurb
          })
        } finally {
          this.loading = false
        }
      }

      if (this.isReurb && tab.name === 'interessado' && this.assinatura.length === 0 && !this.isMaranhao) {
        this.assinatura = await this.buscarFotosReurb({idProcesso: this.processo.id, tipo: 'ASSINATURA'})
      } else if (this.isReurb && tab.name === 'termoCompromisso' && this.assinatura.length === 0) {
        this.assinatura = await this.buscarFotosReurb({idProcesso: this.processo.id, tipo: 'ASSINATURA'})
      }
    },

    possuiCredenciado () {
      if (['NAO_ONEROSO', 'ONEROSO', 'CERTIDAO_TITULO'].includes(this.cadastroOriginal.tipo)) {
        return this.processo.possuiCredenciadoGeo
      }
    },

    getCadastroComPessoaMembroComunidade (index) {
      let mudouCadastranteMembroComunidade = this.compararRetificacoes.mudouCadastranteDTO
      mudouCadastranteMembroComunidade = {
        ...mudouCadastranteMembroComunidade,
        mudouPessoa: mudouCadastranteMembroComunidade.mudouMembroComunidade.length > 0 ? mudouCadastranteMembroComunidade.mudouMembroComunidade[index].mudouPessoa : compararRetificacoesDefault().mudouPessoa,
        mudouEndereco: mudouCadastranteMembroComunidade.mudouMembroComunidade.length > 0 ? mudouCadastranteMembroComunidade.mudouMembroComunidade[index].mudouEndereco : compararRetificacoesDefault().mudouEndereco
      }
      return mudouCadastranteMembroComunidade
    },

    tipoCadastro (tipo) {
      if (this.isBahia && tipo === 'Não Oneroso') {
        return 'Alienação simples doação'
      }

      if (this.isBahia && tipo === 'Oneroso') {
        return 'Alienação Simples Onerosa'
      }
      return tipo
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

  .label {
    font-size: 16px;
  }

  body {
    word-break: break-word !important;
  }

  /deep/ .el-collapse-item__header {
    font-size: 16px;
    color: $font-dark-color;
    font-weight: bold;
  }

  /deep/ .el-collapse-item__content {
    font-size: unset !important;
    color: unset !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/InformacoesCadastroOffline.vue